import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { IS_EMAIL_DEFAULT_OPTIONS } from '@ftr/contracts/shared/validator'
import { isEmail } from 'class-validator'

export const invalidEmailMessage = 'You must enter a valid email.'

export const emailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value: string = control.value
  return isEmail(value, IS_EMAIL_DEFAULT_OPTIONS) ? null : { invalidEmail: invalidEmailMessage }
}

/**
 * A variation of emailValidator for optional values
 */
export const optionalEmailValidator = (control: AbstractControl): ValidationErrors | null => {
  return control.value ? emailValidator(control) : null
}
